
import { defineComponent } from "vue";
import { Timeline, TimelineTitle, TimelineItem } from "vue3-timeline";
import TimeLineCard from "../components/TimeLineCard.vue";
export default defineComponent({
  components: { Timeline, TimelineTitle, TimelineItem, TimeLineCard },
  data() {
    return {};
  },
});
